import { IconProps, iconA11yProps } from '../types';

export const OnDemand = ({ classNames, label }: IconProps) => (
    <svg
        className={classNames}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...iconA11yProps(label)}
    >
        <circle cx="12" cy="12" r="9" />
        <path d="M9.989,15.388l6.023,-3.388l-6.023,-3.388m0,0l0,6.776l4.004,-3.388l-2.993,-2l0,3l1,-1" />
    </svg>
);
